//node modules
import {Col} from "reactstrap";
import {ReactElement} from "react";

//components


//Props settings for SideControlElement
type props = {
  className: string,
  label: string,
  info: string | undefined,
  children?: ReactElement[],
}

export default function SideControlElement({className, label, info, ...props}: props) {
  return (
    <>
      <div className={`${className} row nowrap infoElem`}>
        {props.children ? (
          props.children
        ) : (
          <>
            <Col sm={'auto'}>
              <strong>{label}</strong>
            </Col>
            <Col sm={'auto'}>
              <span>{info}</span>
            </Col>
          </>
        )}
      </div>
    </>
  )
}
